import { action, makeObservable, observable } from 'mobx'

class ProductImageStore {
  uuid
  @observable src
  @observable data
  @observable file

  constructor (data = {}) {
    makeObservable(this)
    Object.assign(this, data)
  }

  @action.bound
  setSrc (value) {
    this.src = value
  }
}

export default ProductImageStore
